import CityPageTemplate from "../city-template/CityPageTemplate";
import { carmelConfig } from "./data";

export default function CarmelPage() {
  return <CityPageTemplate config={carmelConfig} />;
}